import { Form } from "@quillforms/renderer-core";
import "@quillforms/renderer-core/build-style/style.css";
import { registerCoreBlocks } from "@quillforms/react-renderer-utils";
import { blocks } from "./signup.form.blocks";
import "./custom-blocks/dropdown";
import "./custom-blocks/date-picker";
import "./custom-blocks/email";
import "./custom-blocks/masked";
import "./custom-blocks/short-text";
import "./custom-blocks/google-auto-complete";
import "./signup-form.css";

registerCoreBlocks();
const SignUpForm = ({ store, router }) => {

    return (
        <div className="layout">
            <div className="header">
                <img
                    src="https://static-service.opploans-assets.com/assets/webpack/b45d1c126063c10a0fb25867794b55c1.png"
                    alt="virtual-assistant"
                    width={100}
                />
            </div>
            <div className="signup">
                <Form
                    formId={1}
                    applyLogic={true}
                    formObj={blocks}
                    beforeGoingNext={({ answers, currentBlockId, setIsFieldValid, setFieldValidationErr, setIsCurrentBlockSafeToSwipe, goNext }) => {
                        const values = Object.keys(answers).reduce((obj, key) => 
                        ({ ...obj, [key]: Array.isArray(answers[key].value) ? answers[key].value[0] : answers[key].value})
                    , {});
                        switch (currentBlockId) {
                            case "step-0":
                                const onlyDigitsAmount = answers['amount'].value.replace(/\D/g, '');
                                store.commit('updateLoan', { key: 'amount', value: onlyDigitsAmount });
                                store.commit('updateLoan', { key: 'period', value: answers['period'].value });
                                // format to Y-m-d
                                const first_payment_date = answers['first_payment_date'].value;
                                const date = new Date(first_payment_date);
                                const formatted_date = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
                                store.commit('updateLoan', { key: 'first_payment_date', value: formatted_date });
                                break;
                            case "step-7":
                                if (!answers['ssn'].value || !answers['date_of_birth'].value) {
                                    setFieldValidationErr(currentBlockId, '');
                                    return;
                                }
                                if (router.history.current.name === 'create-account') return;
                                store.dispatch('updateContactAtOnce', values);
                                router.push('/create-account');
                            default:
                                store.dispatch('updateContactAtOnce', values);
                        }

                        goNext();
                    }}
                    //   beforeGoingNext={({ answers, currentBlockId, setIsFieldValid, setFieldValidationErr, setIsCurrentBlockSafeToSwipe, goNext }) => {
                    //     // validate that passwords match
                    //     if (currentBlockId === 'step-6') {
                    //       if ((answers['password'] as Record<string, string>).value !== (answers['confirm-password'] as Record<string, string>).value) {
                    //         setIsFieldValid('confirm-password', false);
                    //         setFieldValidationErr('confirm-password', 'Passwords do not match!');
                    //         setIsCurrentBlockSafeToSwipe(false);
                    //       } else {
                    //         setIsFieldValid('confirm-password', true);
                    //         setFieldValidationErr('confirm-password', '');
                    //         setIsCurrentBlockSafeToSwipe(true);
                    //         goNext();
                    //       }
                    //     } else {
                    //       setIsFieldValid(currentBlockId, true);
                    //       setFieldValidationErr(currentBlockId, '');
                    //       setIsCurrentBlockSafeToSwipe(true);
                    //       goNext();
                    //     }
                    //   }}
                    onSubmit={(_data, { completeForm, setIsSubmitting }) => {
                        setTimeout(() => {
                            setIsSubmitting(false);
                            completeForm();
                        }, 500);
                    }}
                />
            </div>
        </div>
    );
};

export default SignUpForm;
